"use strict";

require("core-js/modules/es.number.constructor");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ramda = require("ramda");

var joinOffsetFeathers = function joinOffsetFeathers(offset) {
  return function (query) {
    var isNum = (0, _ramda.is)(Number, offset);
    return (0, _ramda.merge)(query, isNum ? {
      $skip: Math.ceil(offset)
    } : {});
  };
};

var _default = joinOffsetFeathers;
exports.default = _default;